const { REACT_APP_ENV } = process.env;


let config = {
  backend: 'https://www.betarades.gr:2087',
}

// local
if (REACT_APP_ENV === 'local') {
  config = {
    backend: 'http://localhost:2052',
  }
}

// staging
if (REACT_APP_ENV === 'staging') {
  config = {
    backend: 'https://staging-nodejs.betarades.gr:2087',
  }
}

// staging
if (REACT_APP_ENV === 'revamp') {
  config = {
    backend: 'https://staging-revamp-nodejs.betarades.gr:2087',
  }
}

// revamp_production
if (REACT_APP_ENV === 'revamp_prod') {
  config = {
    backend: 'https://nodejs-revamp.betarades.gr:2087',
  }
}

// release
if (REACT_APP_ENV === 'release') {
  config = {
    backend: 'https://release-nodejs.betarades.gr:2087',
  }
}


//production
if (REACT_APP_ENV === 'production') {
  config = {
    backend: 'https://nodejs.betarades.gr:2087'
  }
}

//hetzner production
if (REACT_APP_ENV === 'hetzner-production') {
  config = {
    backend: 'https://www.betarades.gr:2087'
  }
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js